import * as t from "io-ts";
export const signedFileUrlT = t.strict({
    url: t.string,
});
//# sourceMappingURL=files.js.map